/**
 * Marks .zar-img-reveal wrappers when inner img has loaded (or failed), triggering CSS reveal.
 */
(function () {
  function markLoaded(wrap) {
    wrap.classList.add('zar-img-reveal--loaded');
  }

  function bindWrap(wrap) {
    const img = wrap.querySelector('img.zar-img-reveal__img');
    if (!img) return;

    /* Double rAF: ensures first paint uses opacity:0 so the fade/scale transition runs (cached images too). */
    const done = function () {
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          markLoaded(wrap);
        });
      });
    };

    if (img.complete && img.naturalWidth > 0) {
      done();
    } else {
      img.addEventListener('load', done, { once: true });
      img.addEventListener('error', done, { once: true });
    }
  }

  function init() {
    document.querySelectorAll('[data-zar-img-reveal]').forEach(bindWrap);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
